export function install(Vue) {
  Vue.directive('permission', {
    bind(el, binding, vnode) {
      switch (binding.arg) {
        // 10 管理员
        case 'admin':
          if (vnode.context.$store.state.global.previllage !== 10) {
            el.style.display = 'none'
          }
          break
        // previllage: 1,2,10 有读权限就行
        case 'read':
          if (![1, 2, 10].includes(vnode.context.$store.state.global.previllage)) {
            el.style.display = 'none'
          }
          break
        // previllage:2 10 有读写权限
        case 'write':
          if (![2, 10].includes(vnode.context.$store.state.global.previllage)) {
            el.style.display = 'none'
          }
          break
        // previllage:2 10 有读写权限
        case 'normal':
          if (![1, 0].includes(vnode.context.$store.state.global.previllage)) {
            el.style.display = 'none'
          }
          break
      }
    }
  })
}
